import { topics } from "@/mocks/chiagua";

export default function Topics() {
  return (
    <section id="topics" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <p className="font-heading text-2xl text-primary-500 md:text-3xl">🍉 吃瓜话题分类</p>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">按口味挑选你的快乐专区</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            神评论合集、评论区名场面、吃瓜梗图、沙雕热评……不同口味对应不同专区，随手点进就能开啃。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {topics.map((t) => (
            <a
              key={t.id}
              href="#scenes"
              className="group relative overflow-hidden rounded-2xl text-left"
            >
              <div className="aspect-[13/16] w-full overflow-hidden">
                <img
                  src={t.img}
                  alt={`吃瓜话题分类：${t.name}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent p-4">
                <span className="mb-1.5 w-fit rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-bold text-background-50">
                  {t.tag}
                </span>
                <h3 className="text-lg font-black text-background-50">{t.name}</h3>
                <p className="mt-1 flex items-center gap-1 text-xs text-background-100/90 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  去围观 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}